// extracted by mini-css-extract-plugin
export var communityResources = "index-module--communityResources--r9XPu";
export var inner = "index-module--inner--mGpGx";
export var isClosedText = "index-module--isClosedText--74ia-";